export default __webpack_public_path__ + "static/media/Android.afd19bf8.png";